// Generated by CoffeeScript 1.12.7
module.exports = [
  '$scope', '$window', '$location', 'opsSites', function($scope, $window, $location, opsSites) {
    return $scope.logout = function() {
      var logoutUrl;
      logoutUrl = ((opsSites.getUrl('kale')) + "/auth/logout?redirect=") + encodeURIComponent($location.absUrl());
      return $window.location.replace(logoutUrl);
    };
  }
];
